import { useState } from "react";
import { X, Loader2 } from "lucide-react";
import useFirmwareFileUpload from "../../hooks/useFirmwareFileUpload";

export default function UploadFirmwareDialog({ onClose }) {
  const { uploadFirmware, isLoading, error: hookError } = useFirmwareFileUpload();

  const [stationId, setStationId] = useState("");
  const [version, setVersion] = useState("");
  const [file, setFile] = useState(null);
  const [error, setError] = useState("");

    
    
    const handleSubmit = async () => {
    setError("");

    if (!stationId.trim() || !version.trim()) {
        setError("Station ID and Version are required.");
        return;
    }

    if (!file) {
        setError("Please select a .hex file.");
        return;
    }

    // 💥 CHECK FILE EXTENSION
    if (!file.name.toLowerCase().endsWith(".hex")) {
        setError("Only .hex firmware files are allowed.");
        return;
    }

    const res = await uploadFirmware({
        stationId,
        version,
        file,
    });

    if (res.success) {
        alert("Firmware uploaded successfully!");
        onClose();
    } else {
        setError(res.error || "Failed to upload firmware.");
    }
    };


  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4 z-50">
      <div className="bg-white w-full max-w-md rounded-xl shadow-xl border border-gray-200">

        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b">
          <h2 className="text-lg font-semibold text-gray-900">Upload Firmware</h2>
          <button onClick={onClose} className="p-2 rounded-lg hover:bg-gray-100">
            <X size={18} className="text-gray-700" />
          </button>
        </div>

        {/* Body */}
        <div className="px-5 py-5 space-y-4">

          {/* Station ID */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Station ID
            </label>
            <input
              value={stationId}
              onChange={(e) => setStationId(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg bg-gray-50 focus:ring-2"
            />
          </div>

          {/* Version */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Firmware Version
            </label>
            <input
              value={version}
              onChange={(e) => setVersion(e.target.value)}
              placeholder="e.g., v3.0.2"
              className="w-full px-3 py-2 border rounded-lg bg-gray-50 focus:ring-2"
            />
          </div>

          {/* File Input */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Firmware File (.hex)
            </label>
            <input
              type="file"
              accept=".hex"
              onChange={(e) => setFile(e.target.files[0])}
              className="w-full"
            />
          </div>

          {(error || hookError) && (
            <p className="text-sm text-red-600">{error || hookError}</p>
          )}
        </div>

        {/* Footer */}
        <div className="px-5 py-4 border-t flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-100"
          >
            Cancel
          </button>

          <button
            onClick={handleSubmit}
            disabled={isLoading}
            className="px-4 py-2 bg-black text-white rounded-lg flex items-center gap-2 hover:bg-gray-900 disabled:opacity-50"
          >
            {isLoading && <Loader2 className="animate-spin" size={16} />}
            Upload
          </button>
        </div>

      </div>
    </div>
  );
}
